<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title Benutzerverwaltung
    .sub-headline Verwalten Sie alle Nutzer der FeWo Pro Software.
    
    .card.margin-top
        .top
            .left
                .card-headline Alle Benutzer
                .card-description Insgesamt gibt es {{users.filter(u=>u.isActive).length}} aktive Benutzer und {{users.length - users.filter(u=>u.isActive).length}} inaktive Benutzer.
            .right
        .main
            b-table(:data="users"
                    default-sort-direction="asc"
                    default-sort="date"
                    hoverable)
              b-table-column(field='id' label='ID' width='80' centered numeric v-slot="props")
                  | {{ props.row.id }}
              b-table-column(field='firstName' label='Vorname' sortable v-slot="props")
                  | {{ props.row.firstName }}
                  .role
                    .admin(v-if="props.row.role === 'ADMIN'") Admin
              b-table-column(field='lastName' label='Nachname' sortable v-slot="props")
                  | {{ props.row.lastName }}
              b-table-column(field='email' label='E-Mail' sortable v-slot="props")
                  | {{ props.row.email }}
              b-table-column(field='isActive' label='Freigeschaltet' sortable v-slot="props")
                  b-switch(type="is-success"
                  :value="props.row.isActive"
                  :disabled="me.id === props.row.id"
                  @input="updateUserActiveStatus($event, props.row.id)")
              b-table-column(label='Aktionen' v-slot="props")
                  b-button(type="is-danger" size="is-small" @click="confirmDelete(props.row)" :disabled="me.id === props.row.id") Löschen

</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    me() {
      return this.$store.state.me.me;
    },
    users() {
      return this.$store.state.users.all;
    }
  },
  async mounted() {
    await this.$store.dispatch("users/findAll");
  },
  methods: {
    confirmDelete(row) {
      this.$buefy.dialog.confirm({
        title: "Account löschen",
        message: `Sind Sie sicher, dass Sie den <b>Account von ${row.firstName} ${row.lastName} löschen</b> möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Account löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("users/delete", { id: row.id });
            this.$buefy.toast.open("Account gelöscht!");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Account konnte nicht gelöscht werden."
            );
          }
        }
      });
    },
    async updateUserActiveStatus(e, id) {
      await this.$store.dispatch("users/update", { id, isActive: e });
      const user = this.users.find(u=>u.id === id);
      this.$store.dispatch("common/showSuccess", `Benutzer ${user.firstName} ${user.lastName} kann ${e ? 'nun auf FeWo Pro zugreifen.' : 'nicht mehr auf FeWo Pro zugreifen.'}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.role {
  .admin {
    display: inline-block;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 700;
    background-color: springgreen;
    padding: 2px 4px;
    border-radius: 3px;
  }
}
</style>